var boolean_yes_no = function (val) {
  if (val) {
    return 'yes'
  } else {
    return 'no'
  }
};

var format_date = function (date) {
  try {
    return DateHelper.parseDate(date).toString(DateHelper.rubyToDateJS($('#date_format').val()));
  } catch (e) {
    return date;
  }
};

var number_to_currency = function (number, options) {
  try {
    var options   = options || {};
    var precision = options["precision"] || 2;
    var unit      = options["unit"] || "$";
    var separator = precision > 0 ? options["separator"] || $('#separator').val() || "." : "";
    var delimiter = options["delimiter"] || $('#delimiter').val() || ",";

    var parts = parseFloat(number).toFixed(precision).split('.');
    return unit + number_with_delimiter(parts[0], delimiter) + separator + parts[1].toString();
  } catch(e) {
    return number;
  }
};

var number_with_delimiter = function (number, delimiter, separator) {
  try {
    var delimiter = delimiter || $('#delimiter').val() || ",";
    var separator = separator || $('#separator').val() || ".";
    
    var parts = number.toString().split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + delimiter);
    return parts.join(separator);
  } catch(e) {
    return number
  }
};

var number_to_percentage = function (number) {
return (number).toFixed(3) + '%'
};

/* Handlebars helpers */

Handlebars.registerHelper('boolean_yes_no', function (str) {
  return (boolean_yes_no != undefined ? boolean_yes_no(str) : str);
});

Handlebars.registerHelper('format_date', function (date) {
  return (format_date != undefined ? format_date(date) : date);
});

// Handlebars.registerHelper('I18n', function (str) {
//   return (I18n != undefined ? I18n.t(str) : str);
// });

Handlebars.registerHelper('lowercase', function (str) {
  return str.toLowerCase();
});

Handlebars.registerHelper('number_to_currency', function (str) {
  return (number_to_currency != undefined ? number_to_currency(str / 100) : str);
});

Handlebars.registerHelper('number_with_delimiter', function (str) {
  return (number_with_delimiter != undefined ? number_with_delimiter(str) : str);
});

Handlebars.registerHelper('number_to_percentage', function (str) {
  return (number_to_percentage != undefined ? number_to_percentage(str * 100) : str);
});

Handlebars.registerHelper('pluralize', function (str, num) {
  return (pluralize != undefined ? pluralize(str, num) : str);
});

Handlebars.registerHelper('uppercase', function (str) {
  return str.toUpperCase();
});

Handlebars.registerHelper("separator", function (options) {
  if (options.data.last) {
    return options.inverse();
  } else {
    return options.fn();
  }
});

Handlebars.registerHelper("join", function (context, options) {
  var ret = "";

  for (var i = 0, j = context.length; i < j; i++) {
    if(i == j - 1) {
      ret = ret + options.fn(context[i]);
    } else {
      ret = ret + options.fn(context[i]) + (options.hash.delimiter || ", ");
    }
  }

  return ret;
});

Handlebars.registerHelper("if", function (context, options) {
  var isConditionTrue = false 
  var contextArr = []
  var oldContext = context
  var context = context
  var operator = ""
  var comparison = ""
  var break_after_one = false
  
  if (context.split(" ").length > 1) {
    contextArr = context.split(" ")
    context = eval("this." + contextArr[0])
    operator = contextArr[1]
    
    contextArr.shift()
    contextArr.shift()
    
    if (contextArr[contextArr.length - 1] == "break"){
      break_after_one = true
      contextArr.pop()
    }
    comparison = contextArr.join(" ")
  } else {
    context = eval("this." + context)
  }

  switch(operator) {
    case "<":
      isConditionTrue = (context < comparison)
      break;
    case "<=":
      isConditionTrue = (context <= comparison)
      break;
    case "==":
      isConditionTrue = (context == comparison)
      break;
    case "===":
      isConditionTrue = (context === comparison)
      break;
    case "!=":
      isConditionTrue = (context != comparison)
      break;
    case "!==":
      isConditionTrue = (context !== comparison)
      break;
    case ">=":
      isConditionTrue = (context >= comparison)
      break;
    case ">":
      isConditionTrue = (context > comparison)
      break;
    default:
      isConditionTrue = context
  }
  
  if (options.data.root.context) {
    var sameContext = false
    for (var k = 0; k < options.data.root.context.length; k++) {
      if (options.data.root.context[k] == oldContext) {
       sameContext = true
      }
    }
    if (sameContext == false) {
      this.same = false
    }
  }
  
  if(isConditionTrue) {
    if(break_after_one == true) {
      var obj = options.data.root[oldContext.split(".")[0] + "s"]
      for (var i = 0; i < obj.length; i++) {
        if(obj[i] == this && obj[i + 1]) {
          for (var l = i + 1; l < obj.length; l++) {
          	obj[l].same = true
          }
          if(options.data.root.context) {
            var sameContext = false
           	for (var j = 0; j < options.data.root.context.length; j++) {
              if (options.data.root.context[j] == oldContext) {
                sameContext = true
              }
            }
            if (sameContext == false){
              options.data.root.context.push(oldContext)
            }
          } else {
            options.data.root.context = [oldContext]
          }
        }
      }
    }
    
    if (this.same != true) {
      return options.fn(this);
    }
  }
});

Handlebars.registerHelper('sort', function (context, options) {
  var ret = "";
  var arr = options.hash.sort_by.split(" ")
  var sort_columns = []
  var sort_direction = arr[1]
  
  arr[0].split(".").map(function (column) {
    sort_columns.push(column)
  })
   
  if (options.hash.sort_type == "date") {
    context.sort(function(a,b){
      if (sort_direction && sort_direction == "asc") {
        return new Date(b[sort_columns[0]][sort_columns[1]]) - new Date(a[sort_columns[0]][sort_columns[1]]);
      } else {
      	return new Date(a[sort_columns[0]][sort_columns[1]]) - new Date(b[sort_columns[0]][sort_columns[1]]);
      }
    });
  } else if (options.hash.sort_type == "number"){
    context.sort(function(a,b){
      if (sort_direction && sort_direction == "asc") {
        return b[sort_columns[0]][sort_columns[1]] - a[sort_columns[0]][sort_columns[1]];
      } else {
      	return a[sort_columns[0]][sort_columns[1]] - b[sort_columns[0]][sort_columns[1]];
      }
    })
  } else {
    context.sort(function(a,b){
      if (sort_direction && sort_direction == "asc") {
        return b[sort_columns[0]][sort_columns[1]] > a[sort_columns[0]][sort_columns[1]] ? 1 : -1;
      } else {
      	return a[sort_columns[0]][sort_columns[1]] > b[sort_columns[0]][sort_columns[1]] ? 1 : -1;
      }
    })
  }
  
  for (var i = 0, j = context.length; i < j; i++) {
    ret = ret + options.fn(context[i]);
  }

  return ret;
});